"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuery = exports.useReactQuery = void 0;
var react_1 = require("react");
var react_query_1 = require("react-query");
function useReactQuery(key, queryFn, options) {
    if (options === void 0) { options = {}; }
    // Need to track, because react-query doesn't set isError to true when
    // we're in the isLoading state. This allows us to get the error-fetching state.
    var isErrorRef = (0, react_1.useRef)(false);
    var _a = (0, react_query_1.useQuery)(key, queryFn, options), isFetching = _a.isFetching, isError = _a.isError, isSuccess = _a.isSuccess, data = _a.data, error = _a.error, refetch = _a.refetch;
    if (isSuccess) {
        isErrorRef.current = false;
        return {
            status: 'data',
            isFetching: isFetching,
            refetch: refetch,
            // @ts-ignore Must exist
            data: data,
        };
    }
    if (isError || isErrorRef.current) {
        isErrorRef.current = true;
        return {
            status: 'error',
            isFetching: isFetching,
            refetch: refetch,
            // @ts-ignore Must exist
            error: error,
        };
    }
    return {
        status: 'no-data',
        isFetching: isFetching,
    };
}
exports.useReactQuery = useReactQuery;
/**
 * @deprecated use useReactQuery instead.
 */
var useQuery = useReactQuery;
exports.useQuery = useQuery;
